<template>
  <button
      :disabled="isDisable"
      :class="classes"
      :type="type"
      @click="clickOnButton($event)"
  >
    <slot></slot>
    <span v-if="counter" class="tag--counter">{{ counter }}</span>
  </button>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";

export default defineComponent({
  name: "ButtonElement",
  emits: ['clickOnButton'],
  props: {
    type: {
      type: String as PropType<"button" | "submit">,
      default: "button",
    },
    classType: {
      type: String as PropType<"button" | "company" | "dropdown">,
      default: "button",
    },
    size: {
      type: String as PropType<"sm" | "md" | "lg">,
      default: "md",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isInputButton: {
      type: Boolean,
      default: false,
    },
    isElipsisButton: {
      type: Boolean,
      default: false,
    },
    isDraggableButton: {
      type: Boolean,
      default: false,
    },
    notDraggableButton: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      classes: {
        btn: !this.isInputButton,
        "btn-default":
            !this.isInputButton &&
            this.classType !== "company" &&
            this.classType !== "dropdown",
        "btn--ms btn--company": this.classType === "company",
        "input-group-text": this.isInputButton,
        "btn-ellipsis": this.isElipsisButton,
        "btn--draggable": this.isDraggableButton,
        "btn-notdraggable": this.notDraggableButton,
        small: this.size === "sm",
        "btn-large": this.size === "lg",
      },
    };
  },
  methods: {
    clickOnButton(e: Event): void {
      !this.isDisable && this.$emit("clickOnButton", e);
      e.preventDefault();
    },
  },
});
</script>

<!--
  Faz 2a (2026-04-26): SCSS bloğu (önceki 1 980 satır) `button.styles.scss`
  dosyasına çıkarıldı. Vue SFC `src` directive ile bağlandı; scoped davranışı
  ve tüm class'lar birebir korundu. Audit sonucu hiçbir class silinmedi —
  hepsi aktif kullanımda. Detay: ../button/button.styles.scss baş yorumu.
-->
<style scoped lang="scss" src="./button.styles.scss"></style>
